import { useRef } from 'react';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { Camera } from 'lucide-react';

interface CameraButtonProps {
  disabled?: boolean;
  onFileUpload: (files: File[]) => void;
}

export const CameraButton = ({
  disabled = false,
  onFileUpload
}: CameraButtonProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      onFileUpload(files);
    }
    e.target.value = '';
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          capture="environment"
          className="hidden"
          onChange={handleChange}
        />
        <TooltipTrigger asChild>
          <span className="inline-block">
            <Button
              id="camera-button"
              variant="ghost"
              size="icon"
              className="hover:bg-muted"
              disabled={disabled}
              onClick={() => inputRef.current?.click()}
              type="button"
            >
              <Camera className="!size-6" />
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>Take a photo</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CameraButton;
